// extracted by mini-css-extract-plugin
export default {"box1":"Solutions_box1__wa1hd","solutionBox":"Solutions_solutionBox__AwRb9","box":"Solutions_box__Zqlg5","boxT":"Solutions_boxT__z4h2h","boxMain1":"Solutions_boxMain1__W5-m3"};